import React, { useEffect } from "react";
import { Mobile, Default } from "../../../utils/deviceHelpers";
import Container from "@mui/material/Container";
import JotformEmbed from "react-jotform-embed";
import { Typography } from "@mui/material";

export default function AuctionSignUp3(props) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Container maxWidth="xl">
      <Mobile>
        <JotformEmbed src="https://form.jotform.com/210114718244446" />
      </Mobile>
      <Default>
        <Typography variant="articleTitle" className="center">
          Harmony Auction Signup
        </Typography>
        <Typography variant="h6" className="center">
          Part 2 - Returning H&S Customer
        </Typography>
        <JotformEmbed src="https://form.jotform.com/210114718244446" />
      </Default>
    </Container>
  );
}
